
    import {Component, Prop, Vue} from 'vue-property-decorator'
    import SimpleTable from "@/app/common/components/simple-table.vue"
    import {SigningProcessConsumer} from '@/app/product/entities/signing-process-consumer.entity'

    @Component({
        components: {SimpleTable}
    })
    export default class ProductSigningStatus extends Vue {
        @Prop({ required: true }) readonly firstConsumer!: SigningProcessConsumer | null
        @Prop({ required: true }) readonly secondConsumer!: SigningProcessConsumer | null

        get firstConsumerHasSigned(): boolean {
            return !!this.firstConsumer?.signedAt
        }

        get secondConsumerHasSigned(): boolean {
            return !!this.secondConsumer?.signedAt
        }

        get orderedConsumers(): Array<{consumer: SigningProcessConsumer | null, isFirst: boolean}> {
            if (!this.firstConsumer && !this.secondConsumer) {
                return []
            }

            if (!this.secondConsumer) {
                return [{consumer: this.firstConsumer, isFirst: true}]
            }
            
            if (!this.firstConsumerHasSigned && this.secondConsumerHasSigned) {
                return [
                    {consumer: this.firstConsumer, isFirst: true},
                    {consumer: this.secondConsumer, isFirst: false}
                ]
            }

            if (this.firstConsumerHasSigned && !this.secondConsumerHasSigned) {
                return [
                    {consumer: this.secondConsumer, isFirst: false},
                    {consumer: this.firstConsumer, isFirst: true}
                ]
            }

            return [
                {consumer: this.firstConsumer, isFirst: true},
                {consumer: this.secondConsumer, isFirst: false}
            ]
        }

        getChipStyle(item: {consumer: SigningProcessConsumer | null, isFirst: boolean}): object {
            const hasSigned = item.isFirst ? this.firstConsumerHasSigned : this.secondConsumerHasSigned
            
            return {
                backgroundColor: hasSigned ? 'var(--v-success-lighten4)' : 'var(--v-accent-lighten4)',
                color: hasSigned ? 'var(--v-success-darken3)' : 'var(--v-accent-darken3)'
            }
        }

        getChipText(item: {consumer: SigningProcessConsumer | null, isFirst: boolean}): any {
            const hasSigned = item.isFirst ? this.firstConsumerHasSigned : this.secondConsumerHasSigned
            return hasSigned ? this.$t('productaction.status_signed') : this.$t('productaction.status_unsigned')
        }

        getConsumerLabel(item: {consumer: SigningProcessConsumer | null, isFirst: boolean}): any {
            const hasSigned = item.isFirst ? this.firstConsumerHasSigned : this.secondConsumerHasSigned
            return hasSigned ? this.$t('productaction.signed_by') : this.$t('productaction.to_be_signed_by')
        }
    }
